import { useContext } from 'react';

import { UserNotificationsContext } from '../UserNotificationsProvider';

export const useUserNotifications = () => {
  const context = useContext(UserNotificationsContext);
  if (!context) {
    throw new Error('useUserNotification must be used within a UserNotificationProvider');
  }
  return context;
};
